export default __webpack_public_path__ + "static/media/spatula-and-whisk-in-pot.1b29d45f.png";